import {
    GeneralDocumentsService,
    PersonalDocumentsService,
    DocumentsService,
    UserDocumentsService
  } from "@/common/api.service";
  import {
    DOWNLOAD_GENERAL_DOCUMENT,
    FETCH_DOCUMENT,
    DOWNLOAD_PERSONAL_DOCUMENT,
    DOWNLOAD_USER_DOCUMENT,
    FETCH_GENERAL_DOCUMENTS,
    FETCH_PERSONAL_DOCUMENTS,
    ADD_PERSONAL_DOCUMENT,
    FETCH_CREATE_DOCUMENT,
    DELETE_PERSONAL_DOCUMENT,
    FETCH_INDIVIDUAL_PERSONAL_DOCUMENT,
    UPDATE_PERSONAL_DOCUMENT,
    FETCH_USER_DOCUMENTS,
    UPDATE_USER_DOCUMENT,
    RESET_STATE
  } from "./actions.type";
  import {
    SET_GENERAL_DOCUMENTS,
    SET_PERSONAL_DOCUMENTS,
    SET_INDIVIDUAL_PERSONAL_DOCUMENT,
    SET_DOCUMENT,
    SET_CREATE_DOCUMENT,
    SET_DOCUMENTS_ERROR,
    SET_USER_DOCUMENTS,
    STATE_RESET
  } from "./mutations.type";
  
  const initialState = () => {
    return {
      documentsdata: [],
      generaldocuments: [],
      individualpersonaldocument: {},
      userdocuments:[],
      createdocuments:[],
      personaldocuments: [],
      documenterrors: null,
    }
  };
  
  let state = initialState()
  
  const getters = {
    documentsdata(state) {
      return state.documentsdata
    },      
    userdocuments(state) {
      return state.userdocuments
    },    
    createdocuments(state) {
      return state.createdocuments
    },
    generaldocuments(state) {
      return state.generaldocuments
    },
    personaldocuments(state) {
      return state.personaldocuments
    },
    individualpersonaldocument(state){
      return state.individualpersonaldocument
    }
  };
  
  const actions = {
    async [FETCH_DOCUMENT](context, slug) {
      const {
        data
      } = await DocumentsService.get(slug);
      context.commit(SET_DOCUMENT, data.data);
      return data;
    },
    async [FETCH_CREATE_DOCUMENT](context, slug) {
      const {
        data
      } = await UserDocumentsService.get(slug);
      context.commit(SET_CREATE_DOCUMENT, data.data);
      return data;
    },

    async [FETCH_GENERAL_DOCUMENTS](context, gendocid) {
      const {
        data
      } = await GeneralDocumentsService.get(gendocid);
      context.commit(SET_GENERAL_DOCUMENTS, data.data);
      return data;
    },
    async [DOWNLOAD_GENERAL_DOCUMENT](context, payload) {
      return await GeneralDocumentsService.downloadFile(payload)
        .then(data => {
          return data
        })
        .catch(error => {
          context.commit(SET_DOCUMENTS_ERROR, (error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message));
        });
    },
    async [FETCH_USER_DOCUMENTS](context,slug) {
      const {
        data
      } = await UserDocumentsService.get(slug);
      context.commit(SET_USER_DOCUMENTS, data.data);
      return data;
    },  
    async [DOWNLOAD_USER_DOCUMENT](context, payload) {
      return await UserDocumentsService.downloadFile(payload)
        .then(({data}) => {
          return data
        })
        .catch(error => {
          context.commit(SET_DOCUMENTS_ERROR, (error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message));
        });
    },
    async [DELETE_PERSONAL_DOCUMENT] (context, id) {
      return await PersonalDocumentsService.delete(id)
      .then(({ data }) => {
        return data
      })
      .catch(error => {
        context.commit(SET_DOCUMENTS_ERROR, error.response.data.errors)
      });
  }, 


    async [UPDATE_USER_DOCUMENT](context, payload) {
        return await UserDocumentsService.update(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
            context.commit(SET_DOCUMENTS_ERROR, (error.response.data.hasOwnProperty('errors')? error.response.data.errors   : error.response.data.message));
        });
    },     
    async [FETCH_PERSONAL_DOCUMENTS](context, perdocid) {
      const {
        data
      } = await PersonalDocumentsService.get(perdocid);
      context.commit(SET_PERSONAL_DOCUMENTS, data.data);
      return data;
    },
    async [FETCH_INDIVIDUAL_PERSONAL_DOCUMENT](context, perdocid) {
      const {
        data
      } = await PersonalDocumentsService.get(perdocid);
      context.commit(SET_INDIVIDUAL_PERSONAL_DOCUMENT, data.data);
      return data;
    },

    async [DOWNLOAD_PERSONAL_DOCUMENT](context, payload) {
      return await PersonalDocumentsService.downloadFile(payload)
        .then(({
          data
        }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_DOCUMENTS_ERROR, (error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message));
        });
    },
    async [UPDATE_PERSONAL_DOCUMENT](context, payload) {
      return await PersonalDocumentsService.update(payload)
      .then(({ data }) => {
        return data
      })
      .catch(error => {
          context.commit(SET_DOCUMENTS_ERROR, (error.response.data.hasOwnProperty('errors')? error.response.data.errors   : error.response.data.message));
      });
    },  
    async [ADD_PERSONAL_DOCUMENT](context, payload) {
      return await PersonalDocumentsService.create(payload)
      .then(({ data }) => {
        return data
      })
      .catch(error => {
          context.commit(SET_DOCUMENTS_ERROR, (error.response.data.hasOwnProperty('errors')? error.response.data.errors   : error.response.data.message));
      });
    }, 


    [RESET_STATE]({
      commit
    }) {
      commit(STATE_RESET);
    }
  
  }
  
  const mutations = {
    [SET_DOCUMENT](state, documents) {
      state.documentsdata = documents;
    },
    [SET_CREATE_DOCUMENT](state, createdocuments) {
      state.createdocuments = createdocuments
    },    
    [SET_GENERAL_DOCUMENTS](state, generaldocuments) {
      state.generaldocuments = generaldocuments;
    },
    [SET_PERSONAL_DOCUMENTS](state, personaldocuments) {
      state.personaldocuments = personaldocuments;
    },
    [SET_USER_DOCUMENTS](state, userdocuments) {
      state.userdocuments = userdocuments;
    },  
    [SET_INDIVIDUAL_PERSONAL_DOCUMENT](state, individualpersonaldocument) {
      state.individualpersonaldocument = individualpersonaldocument;
    },     
    [SET_DOCUMENTS_ERROR](state, error) {
      state.documenterrors = error;
    },
    [STATE_RESET](state) {
      Object.assign(state, initialState())
    }
  };
  
  export default {
    state,
    getters,
    actions,
    mutations
  };
  